import { many, map, opt, Parser, seq } from "./core";

/**
 * Given a {@link parser} separated by elements described by {@link separator}
 * @returns an array of those elements that are separated
 */
export function join<T, S>(
  parser: Parser<T, S>,
  separator: Parser<T, unknown>
): Parser<T, S[]> {
  const separatorAndToken = map(seq(separator, parser), (el) => el[1]);
  const rest = opt(many(separatorAndToken));
  return map(seq(parser, rest), (el) => {
    // the very last element doesn't end in a separator
    if (el[1] == undefined) return [el[0]];
    return [el[0], ...el[1]];
  });
}

/**
 * Makes sure that the {@link text} is fully described by the {@link parser}
 */
export function matches<T extends string>(
  parser: Parser<T, unknown>,
  text: T
): boolean {
  const res = parser(text, 0);
  return res.success && res.position == text.length;
}
